export default __webpack_public_path__ + "media/images/avatars/avatar18-ed74afc797a4dc9c28ef92983ac515e0.png";